import { createContext, useContext } from 'react';

import type { AppUser } from './types';

export interface AuthContextValue {
  user: AppUser | null;
  loading: boolean;
  error: string | null;
  locked: boolean;
  signInWithPin: (pin: string) => Promise<void>;
  unlockWithPin: (pin: string) => Promise<void>;
  retry: () => void;
  lock: () => void;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth mora biti uporabljen z AuthProvider.');
  return context;
}
